import styled from 'styled-components';

export const Document = styled.div`
  padding: 1rem;
`;

export const Products = styled.div`
  padding: 1rem;
`;
